import { defineComponent as _defineComponent } from 'vue'
import { MaterialGroup } from '@/models/materialGroup';
import { materialGroupsService } from '@/services/materialGroups.service';
import { Customer } from '@/models/tenant';
import { isEmpty } from '@/utils/misc';
import { computed, reactive, ref } from 'vue';
import { useI18n } from '@/composables/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'MaterialGroupCreationModal',
  props: {
    customer: null
  },
  emits: ['save', 'close'],
  setup(__props: any, { emit }) {

const props = __props as {
  customer: Customer;
};





const materialGroup = reactive(MaterialGroup.GetEmpty());

const isSubmitting = ref(false);

const { t } = useI18n();

function onSubmit() {
  isSubmitting.value = true;
  materialGroup.tenantId = props.customer.id;

  materialGroupsService
    .create(materialGroup)
    .then(() => {
      emit('save');
      closeModal();
    })
    .finally(() => (isSubmitting.value = false));
}

function closeModal() {
  emit('close');
}

const canSubmit = computed(() => !isEmpty(materialGroup.name));

return { __sfc: true,props, emit, materialGroup, isSubmitting, t, onSubmit, closeModal, canSubmit }
}

})